import {BibliographyItem} from '../../admin/publications/types/BibliographyItem';
import {PublicationItemsCacheService} from '../../common/services/publicationItemsCacheService';

class BibliographyItemsCacheService extends PublicationItemsCacheService<BibliographyItem> {
  constructor() {
    super('/bibliography-items', 'Error fetching bibliography items for publication:');
  }

  public async getBibliographyItemsForPublication(publicationId: string): Promise<BibliographyItem[]> {
    return this.getItemsForPublication(publicationId);
  }

  public getBibliographyItemContentByAbbreviation(publicationId: string, abbreviation: string): string | undefined {
    const item = this.getItemByAbbreviation(publicationId, abbreviation);
    return item?.content;
  }
}

export default new BibliographyItemsCacheService();

